import { LabelMap } from "./tabLabelMap";
import { AVERAGEDAY } from "@dcc/types/averageDay";
import { DrinkingDayTabEnabled } from "@dcc/common/drinkingDayUtils";

export const averageDayTabLabels: LabelMap = {
  [AVERAGEDAY]: {
    short: "Average Day",
    long: "Average Day"
  }
};

export const tabsEnabled: DrinkingDayTabEnabled = {
  [AVERAGEDAY]: true
};
